import client from './client';
import type { Instrument, InstrumentCategory, MemberInstrument } from '../types/instrument';

export async function listMinistryInstruments(ministryId: string): Promise<Instrument[]> {
  const res = await client.get(`/ministries/${ministryId}/instruments/`);
  return res.data;
}

export async function createMinistryInstrument(
  ministryId: string,
  name: string,
  category: InstrumentCategory
): Promise<Instrument> {
  const res = await client.post(`/ministries/${ministryId}/instruments/`, { name, category });
  return res.data;
}

export async function deleteMinistryInstrument(ministryId: string, instrumentId: string): Promise<void> {
  await client.delete(`/ministries/${ministryId}/instruments/${instrumentId}/`);
}

export async function listMemberInstruments(ministryId: string, userId: string): Promise<MemberInstrument[]> {
  const res = await client.get(`/ministries/${ministryId}/instruments/members/${userId}/`);
  return res.data;
}

export async function assignInstrument(
  ministryId: string,
  userId: string,
  instrumentId: string,
  isPrimary = false
): Promise<MemberInstrument> {
  const res = await client.post(`/ministries/${ministryId}/instruments/members/${userId}/`, {
    instrument_id: instrumentId,
    is_primary: isPrimary,
  });
  return res.data;
}

export async function unassignInstrument(ministryId: string, userId: string, instrumentId: string): Promise<void> {
  await client.delete(`/ministries/${ministryId}/instruments/members/${userId}/${instrumentId}/`);
}

export async function setPrimaryInstrument(
  ministryId: string,
  userId: string,
  instrumentId: string
): Promise<MemberInstrument> {
  const res = await client.patch(`/ministries/${ministryId}/instruments/members/${userId}/${instrumentId}/`);
  return res.data;
}
